var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"flex py-4"},[_c('logos'),_c('div',{staticClass:"ml-auto md:hidden"},[_c('survey-percentage',{attrs:{"percentage":_vm.pagePercent}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }